// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__IXyDm","image":"App_image__1w7pB"};